<template>
  <div>
    <VAppBar
      app
      dark
      color="primary"
    >
      <VAppBarNavIcon @click="showSidebar = !showSidebar" />
      <slot name="CenterContent" >
        <VToolbarTitle>{{ c_HeaderTitle }}</VToolbarTitle>
      </slot>
      <VSpacer />

      <slot name="RightContent" />
      <UserActions>
        <template #UserActions>
          <slot name="UserActions" />
        </template>
      </UserActions>
      <!-- <VBtn
        v-debug
        icon
        @click="toggleAppTheme"
      >
        <VIcon>{{ $vuetify.theme.dark ? 'mdi-weather-night' : 'mdi-weather-sunny' }}</VIcon>
      </VBtn> -->
    </VAppBar>
    <Sidebar
      v-model="showSidebar"
      :main-title="sidebarTitle"
      :list="sidebarList"
      :main-avatar-image="sidebarAvatarImage"
      :main-avatar-icon="sidebarAvatarIcon"
    />
    <VMain>
      <RouterView />
    </VMain>
    <VFooter
      v-if="showFooter"
      app
      dark
      :color="headerColor"
    >
      {{ footerText }}
    </VFooter>
  </div>
</template>

<script>
import UserActions from '@/components/layouts/Header/UserActions'
import Sidebar from '@/components/layouts/Sidebar/Sidebar'

export default {
  components: {
    UserActions,
    Sidebar
  },
  props: {
    sidebarTitle: {
      type: String,
      default: import.meta.env.VITE_APP_TITLE
    },
    sidebarList: {
      type: Array,
      default: () => [
        {
          title: 'Section_1',
          items: [
            {
              title: 'Child_1.1',
              icon: 'mdi-view-dashboard',
              to: { name: '' },
              child: [
                {
                  title: 'Grandchild_1.1.1',
                  icon: 'mdi-view-dashboard',
                  to: { name: '' },
                }
              ]
            }
          ]
        }
      ]
    },
    sidebarAvatarIcon: {
      type: String,
      default: 'mdi-vuetify'
    },
    sidebarAvatarImage: {
      type: String,
      default: require('@/assets/images/favicon.png')
    },
    footerText: {
      type: String,
      default: '© ' + new Date().getFullYear() + ' ' + import.meta.env.VITE_APP_TITLE
    },
  },
  data () {
    return {
      showSidebar: false
    }
  },
  computed: {
    c_HeaderTitle () {
      return this.getAppHeaderTitle ?? this.$route.name
    },
    headerColor () {
      return this.getAppHeaderColor ?? 'primary'
    },
    showFooter () {
      //  use router meta
      return this.$route.meta.showFooter ?? true
    },
  }
}
</script>
